import React, { useEffect, useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'

import SettingsIcon from 'Assets/Images/icons/settings'
import { PATHS } from 'Config/Routing/paths'
import TagsManagementForm from '../TagsManagementForm'
import { TAGS_MANAGEMENT_FORM_MODES } from '../const'
import useGraphQLFetch from '../../../../Utils/Hooks/useGraphQLFetch'
import { editTagGQL, getTagGQL } from './gql'
import { styles } from './styles'
import StyledBreadcrumbs from '../../../../Components/StyledBreadcrumbs'

const BreadcrumbsEditTag = () => {
  return (
    <StyledBreadcrumbs
      icon={<SettingsIcon style={{ width: 20 }} />}
      breadcrumbs={[
        {
          label: 'Settings',
          link: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
        },
        {
          label: 'Tags Management',
          link: `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.tagsManagement
          }`,
        },
        { label: 'Edit' },
      ]}
    />
  )
}

const TagsManagementEdit = ({ classes }) => {
  const match = useRouteMatch()
  const history = useHistory()
  const [tagData, setTagData] = useState(null)
  const [loading, setLoading] = useState(false)

  const { data, isLoaded } = useGraphQLFetch({
    fetchFn: getTagGQL,
    defaultFetchArgs: { tagIds: match.params.id },
    mapResponse: data => data.getTags.edges[0].node,
  })
  useEffect(() => {
    if (isLoaded) setTagData(data)
  }, [isLoaded])
  const navigateBack = () => {
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
        PATHS.settings.tagsManagement
      }`,
    )
  }

  const handleEditSubmit = async (form, isValid) => {
    if (isValid) {
      setLoading(true)
      const { name, type } = form
      try {
        await editTagGQL({
          value: name.value,
          type: type.value,
          id: match.params.id,
        })
        navigateBack()
      } finally {
        setLoading(false)
      }
    }
  }
  return (
    <div className={classes.wrapper}>
      <BreadcrumbsEditTag />
      {isLoaded && tagData ? (
        <TagsManagementForm
          mode={TAGS_MANAGEMENT_FORM_MODES.EDIT}
          handleCancel={navigateBack}
          defaultValues={tagData}
          buttonsDisabled={loading}
          handleSubmit={handleEditSubmit}
        />
      ) : null}
    </div>
  )
}

export default withStyles(styles)(TagsManagementEdit)
